export default __webpack_public_path__ + "static/media/221.7a9fcd64.gif";